import React from "react";
import s from "./LandingHeader.module.scss";
import { Link, useLocation } from "react-router-dom";
import { Dropdown } from "antd";
import { useDispatch } from "react-redux";
import { DownOutlined, LoginOutlined } from "@ant-design/icons";
import { getNews } from "../../../../redux/LangingPageSlice";

const aboutItems = [
  { key: "/history", label: <Link to="/history">History</Link> },
  { key: "/aboutMctac", label: <Link to="/aboutMctac">What is MCTAC</Link> },
  {
    key: "/aboutHub",
    label: <Link to="/aboutHub">About Digital Transit Hub</Link>,
  },
  {
    key: "/regionalRepresentatives",
    label: <Link to="/regionalRepresentatives">Regional Representatives</Link>,
  },
];

const Header = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const isActive = (path) =>
    path === "/"
      ? pathname === "/" || pathname === "/home"
      : pathname.startsWith(path);
  const aboutActive = aboutItems.some((it) => isActive(it.key));
  const itemClass = (active) =>
    active ? `${s.menu_item} ${s.active}` : s.menu_item;

  return (
    <header className={isActive("/") ? `${s.header} ${s.on_dark}` : s.header}>
      <div className={s.inner}>
        <Link to="/" className={s.brand}>
          <img src="/images/moldovas_gerb.png" className={s.logo} alt="MCTAC" />
          <span className={s.brand_name}>ANV-MCTAC</span>
        </Link>

        <nav className={s.menu}>
          <Link to="/" className={itemClass(isActive("/"))}>
            Home
          </Link>
          <Dropdown
            menu={{
              items: aboutItems,
              selectable: true,
              selectedKeys: aboutItems
                .map((it) => it.key)
                .filter((key) => isActive(key)),
            }}
            rootClassName={s.dropdown}
          >
            <span className={itemClass(aboutActive)}>
              About us <DownOutlined className={s.caret} />
            </span>
          </Dropdown>
          <Link to="/committee" className={itemClass(isActive("/committee"))}>
            Advisory Committee
          </Link>
          <Link
            to="/news"
            onClick={() => dispatch(getNews())}
            className={itemClass(isActive("/news"))}
          >
            News & Events
          </Link>
        </nav>

        <Link to="/signIn" className={s.cta}>
          <LoginOutlined />
          <span className={s.cta_text}>Digital Transit HUB</span>
        </Link>
      </div>
    </header>
  );
};

export default Header;
